import { gql } from '@apollo/client';
import { tenant,tenantType } from '../tenant';

const QUERY_SERVICE=gql`
subscription Service {
  clubmate_clubmateservice_clubmateservice(where:{archive:{_eq:false}}) {
    name
    price
    visible_for_partner
    description
    id
    archive
    entrance_service
    request_entrance_for_use
    service_group_id
  }
}
`

const QUERY_SERVICE_ARCHIVED=gql`
subscription Service {
  clubmate_clubmateservice_clubmateservice(where:{archive:{_eq:true}}) {
    name
    price
    visible_for_partner
    description
    id
    archive
    entrance_service
    request_entrance_for_use
    service_group_id
  }
}
`

const QUERY_SERVICE_GROUPS=gql`
subscription ServiceGroups {
  clubmate_clubmateservice_clubmateservicegroup {
    id
    name
  }
}
`

const QUERY_AREA=gql`
subscription Area {
  clubmate_clubmatearea_clubmatearea {
    archive
    coordinate
    id
    is_alias
    name
  }
}
`
const QUERY_PACKAGE=gql`
subscription Package {
  clubmate_clubmatepackage_clubmatepackage {
    id
    name
    number_of_entry
    price
    entry_package
    duration_in_days
    duration_in_month
    solar_package
  }
}
`

const QUERY_USERS=gql`
subscription Users {
  clubmate_usersregister_userregister {
    id
    fiscal_code
    name
    surname
    telephone_number
    external_erp_code
    date_of_birth
    partner
    wallet_id
    golf_card_number
  }
}
`

const QUERY_JOBS=gql`
subscription Jobs($areeId:[bigint!]){
  ${tenant}_jobs_job${tenantType}(where:{jobs_jobsareas:{area_id:{_in:$areeId}}}, order_by: {name: asc}){
    id
    name
    external_erp_code
    jobs_jobsareas{
      id
      area_id
      job_id
    }
  }
}
`

const QUERY_MACHINE=gql`
subscription GetMachine($areeId:[bigint!]){
  ${tenant}_machines_machine${tenantType}(where:{machines_machineareas:{area_id:{_in:$areeId}}}, order_by: {name: asc}){
    id
    name
    chassis_number
    fuel
    year
    external_erp_code
    hourly_cost
    notes
    car_service
    initial_machine_time
    hourly_rental_cost
    machineType_machinetype{
      id
      type_name
    }
    machine_value
   	machines_canmachines{
      id
      machines_can{
        id
        can_number
      }
    }
    accessories
    machineType_machinetype{
      id
      type_name
    }
    machines_machineareas{
      id
      area_area${tenantType}{
        id
        name
      }
    }
    machines_machinejobs{
      id
      jobs_job${tenantType}{
        id
        name
      }
    }
  }
}
`
const QUERY_MACHINE_TYPE=gql`
subscription MachineType{
  machineType_machinetype{
    id
    type_name
    machineType_typesschedules(order_by: {machineType_maintenanceschedule: {interval: asc}}){
      id
    	machineType_maintenanceschedule{
        id
        interval
        machineType_interventiontype{
          id
      	 code
          note
        }
      }
    }
  }
}
`

const QUERY_SINGLE_MACHINE_TYPE=gql`
query MachineType($id:bigint!){
  machineType_machinetype_by_pk(id:$id){
    id
    type_name
    machineType_typesschedules(order_by: {machineType_maintenanceschedule: {interval: asc}}){
      id
    	machineType_maintenanceschedule{
        id
        interval
        machineType_interventiontype{
          id
      	  code
          note
        }
      }
    }
  }
}
`



export {QUERY_USERS,QUERY_JOBS,QUERY_MACHINE,QUERY_MACHINE_TYPE,QUERY_SINGLE_MACHINE_TYPE,QUERY_PACKAGE, QUERY_AREA, QUERY_SERVICE, QUERY_SERVICE_ARCHIVED, QUERY_SERVICE_GROUPS};